import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../context/AuthContext';
import { useContextGlobal } from '../../context/ContextGlobal';
import { useToast } from '../../context/ToastContext';
import { handleExceptionMessage } from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';
import { FormInputProps } from '../../componets/form/formInterfaces';
import image from '../../assets/images/40635-ffffff.svg';
import './styles.scss';
import { texts } from '../../config';
import { Alert, AlertColor, Grid, Link } from '@mui/material';
import api from '../../services/api';
import RenderForm from '../../componets/form/renderForm';

interface IFormInput {
    password: string;
}

const defaultValues = {
    password: '',
};

const ForgotPassword: React.FC = () => {
    const history = useHistory();
    const { addToast } = useToast();
    const { setOpenLoading } = useContextGlobal();
    const [messageAlert, setMessageAlert] = React.useState({
        active: false,
        type: 'success',
        message: '',
    });

    const { handleSubmit, control,  watch } =
        useForm<IFormInput>({
            defaultValues,
        });

    const inputsForm: FormInputProps<IFormInput>[] = [
        {
            typeInput: 'password',
            name: 'password',
            control: control,
            label: 'Senha',
            md: 12,
            xs: 12,
            rules: {
                pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,15}$/,
            },
            messagesError: [
                {
                    type: 'pattern',
                    message:
                        'A senha tem que ter de 6 a 15 caracteres, ao menos uma letra e ao menos um número',
                },
            ],
        },
        {
            typeInput: 'password',
            name: 'passwordConfirmation',
            control: control,
            label: 'Confirmar senha',
            md: 12,
            xs: 12,
            rules: {
                validate: (val: string) => {
                    if (val && watch('password') != val) {
                        return 'As senhas não conferem';
                    }
                },
            },
        },
    ];

    const submit = async (data: IFormInput, e: any) => {
        e.preventDefault();
        setOpenLoading(true);

        try {
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token');
            const id = params.get('id');

            let config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            await api.patch(`auth/reset-password/${id}`, {
                password: data.password,
            }, config);
            history.push('/');

            setMessageAlert(prev => ({
                ...prev,
                active: true,
                type: 'success',
                message:
                    'Um e-mail com instruções para redefinir sua senha foi enviado para o endereço informado.',
            }));
            setOpenLoading(false);
        } catch (error) {
            setOpenLoading(false);

            const { messageResponse, typeFeedback } = handleExceptionMessage(error);
            addToast({
                type: typeFeedback,
                title: message.error.save,
                description: messageResponse,
            });
        }
    };

    return (
        <div className="container">
            <div className="main-container">
                {/* <CssBaseline /> */}
                <div className="main">
                    <Avatar sx={{ bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        GESSIS
                    </Typography>
                    <br />
                    {messageAlert?.active && (
                        <Alert
                            severity={messageAlert.type as AlertColor}
                            sx={{
                                mb: 2,
                                borderRadius: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                            }}>
                            {messageAlert.message}
                        </Alert>
                    )}
                    <form
                        style={{ width: '100%' }}
                        onSubmit={handleSubmit(submit)}>
                        <Grid container spacing={2}>
                            <RenderForm
                                inputsForm={inputsForm.filter(
                                    i => !i?.noRender,
                                )}
                            />
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}>
                            Entrar
                        </Button>
                    </form>
                </div>
                <div className="main-image">
                    <div className="container-title">
                        <h2>{texts.nameSystem}</h2>
                        <h6>{texts.info}</h6>
                        <img
                            src={image}
                            alt="Gessis"
                            width={'100%'}
                            color="#191919"
                        />
                    </div>
                </div>
            </div>
            <footer className="footer" style={{}}>
                <Typography variant="body2" color="textPrimary" align="center">
                    {`Copyright © ${texts.nameSystem} `}
                    {new Date().getFullYear()}
                    {'.'}
                </Typography>
            </footer>
        </div>
    );
};

export default ForgotPassword;
